import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getOwnHarbours() {
  const data = await apiGet('helper/ownHarbours');
  useHelperStore().setOwnHarbours(data);
}
